import OfficeHoursDelete from './office-hours-delete';

export default OfficeHoursDelete;
